import { Component, Input, OnInit, inject } from '@angular/core';
import { PatientAttachment } from '../../../core/models/patient-attachment.model';
import { Capture } from '../../../core/models/capture.model';
import { PdfFileType } from '../../../core/enums/pdf-file-type.enum';
import { PatientAttachmentsService } from '../../../core/services/patient-attachments.service';
import { AuthenticationService } from '../../../core/services/authentication.service';
import { environment } from '../../../../environments/environment';
import { EhrConsultNoteReference } from 'app/core/models/ehr-consult-note-reference.model';

import { PdfFileViewerComponent } from '../../../shared/components/pdf-file-viewer/pdf-file-viewer.component';
import { PdfkitFileViewerComponent } from '../../../shared/components/pdfkit-file-viewer/pdfkit-file-viewer.component';
import { EhrConsultNoteReferenceComponent } from '../ehr-consult-note-reference/ehr-consult-note-reference.component';

@Component({
    selector: 'app-patient-document',
    templateUrl: './patient-document.component.html',
    imports: [PdfFileViewerComponent, PdfkitFileViewerComponent, EhrConsultNoteReferenceComponent]
})
export class PatientDocumentComponent implements OnInit {
  private authService = inject(AuthenticationService);
  private patientAttachmentsService = inject(PatientAttachmentsService);

  @Input() capture: Capture;
  @Input() selectedAttachment: PatientAttachment;

  pdfFileType: PdfFileType = PdfFileType.patientAttachment;
  initialPage = null;
  activePage = null;
  hidePdfRotationControls = false;
  usePdfKitViewer: boolean;

  ngOnInit() {
    this.hidePdfRotationControls = !this.authService.isCaptureAdminUser;
    this.usePdfKitViewer = environment.featureData?.usePdfKitViewer
    this.initialize();
  }

  onEhrConsultNoteReferenceUpdated(updatedEhrConsultNoteReference: EhrConsultNoteReference) {
    this.selectedAttachment.ehrConsultNoteReference = updatedEhrConsultNoteReference;
  }

  public onPageChange(page: number) {
    this.activePage = page;
  }

  public onUrlChange(url: string) {
    this.selectedAttachment.url = url;
  }

  public onDocumentClick($event: MouseEvent) {
    if ($event.altKey) {
      this.updatePatientAttachment();
    }
  }

  private initialize() {
    this.initialPage = (this.selectedAttachment && this.selectedAttachment.medicationsPage) || 1;
    this.activePage = this.initialPage;
  }

  private updatePatientAttachment() {
    this.selectedAttachment.medicationsPage = this.activePage;

    this.patientAttachmentsService.update(this.selectedAttachment).subscribe(pa => {
      this.patientAttachmentsService.notifyPatientAttachmentChanged(pa);
    });
  }
}
